import { urls } from 'constants/urls';
import { delay, http, HttpResponse } from 'msw';

const tracking = [
  http.post(`https://gateway.fretebras.dev.br/${urls.tracking.jaiminho}`, async () => {
    await delay();
    return HttpResponse.json(null, { status: 200 });
  }),
];

export { tracking };
